import React, { useMemo } from 'react'
import { HtmlEditor } from 'scenes/Dashboard/components/HtmlEditor'

import { createStyles, Theme, Typography } from '@mui/material'
import { WithStyles, withStyles } from '@mui/styles'

type EditorFieldProps = WithStyles<typeof styles> & {
  label: string
  onChange: (html: string) => void
  value: string
}

function EditorField({ classes, label, onChange, value }: EditorFieldProps) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initialValue = useMemo(() => value || '', [])

  return (
    <>
      <Typography className={classes.label} variant="caption">
        {label}
      </Typography>

      <HtmlEditor className={classes.editor} initialContent={initialValue} value={value} onChange={onChange} />
    </>
  )
}

const styles = ({ spacing }: Theme) =>
  createStyles({
    editor: {
      marginBottom: spacing(2),
    },

    label: {
      display: 'block',
      marginBottom: spacing(1),
    },
  })

export default withStyles(styles)(EditorField)
